import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + "/api";

export function getSearchResult(data) {
    return axios.get(`${API_ENDPOINT}/place/SearcheEverywhereCount?filter=${data}`, { headers: getHeaderOptions() })
}

export function getSearchEverywhere(data) {
    return axios.put(`${API_ENDPOINT}/place/SearcheEverywhere`, data, { headers: getHeaderOptions() })
}